<template>
  <ChartCard
    ref="target"
    title="Devices"
    :is-loading="isLoading"
    :timestamp="allData ? allData.timestamp : null"
    :padding-bottom="false"
  >
    <DevicesTable
      type="views"
      :is-loading="isLoading"
      :data="data"
      :all-data="allData"
    />
  </ChartCard>
</template>

<script>
import ChartCard from './chart-card';
import { DevicesTable } from '../charts';

export default {
  components: {
    ChartCard,
    DevicesTable,
  },

  props: {
    allData: {
      type: Object,
      default: null,
    },

    data: {
      type: Array,
      default: null,
    },

    isLoading: Boolean,
  },
};
</script>

<style lang="scss" scoped></style>
